import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import api from "../../service/api";

export default function ActionFormDialog({ open, onClose, formId }) {
    const [actions, setActions] = useState([]);
    const [newAction, setNewAction] = useState("");
    const [loading, setLoading] = useState(false);

    // Buscar ações ao abrir o dialog
    useEffect(() => {
        if (open) {
            fetchActions();
        }
    }, [open]);

    const fetchActions = async () => {
        try {
            setLoading(true);
            const res = await api.get(`action-forms/${formId.id}/actions`);
            setActions(res.data);
        } catch (err) {
            console.error("Erro ao carregar ações", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async () => {
        if (!newAction.trim()) return;
        try {
            const res = await api.post(`action-forms/${formId.id}/actions`, {
                name: newAction,
            });
            setActions((prev) => [...prev, res.data]);
            setNewAction("");
        } catch (err) {
            console.error("Erro ao criar ação", err);
        }
    };

    const handleDelete = async (actionId) => {
        try {
            await api.delete(`action-forms/${formId.id}/actions/${actionId}`);
            setActions((prev) => prev.filter((a) => a.id !== actionId));
        } catch (err) {
            console.error("Erro ao excluir ação", err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Gerenciar Botões do Formulário</DialogTitle>

            <DialogContent dividers>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <List>
                            {actions.map((action) => (
                                <ListItem key={action.id}>
                                    <ListItemText primary={action.name} />
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            edge="end"
                                            color="error"
                                            onClick={() => handleDelete(action.id)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>

                        <div
                            style={{
                                display: "flex",
                                marginTop: 16,
                                gap: 8,
                            }}
                        >
                            <TextField
                                label="Nome do botão"
                                variant="outlined"
                                fullWidth
                                size="small"
                                value={newAction}
                                onChange={(e) => setNewAction(e.target.value)}
                            />
                            <IconButton color="primary" onClick={handleAdd}>
                                <AddIcon />
                            </IconButton>
                        </div>
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
